import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/images/left.png';
import _imports_1 from '../../../assets/images/right.png';
import _imports_2 from '../../../assets/images/right_l.png';

const _withScopeId = n => (_pushScopeId("data-v-2596878b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ExcitingClassroom"
};
const _hoisted_2 = {
  key: 0,
  class: "swiper-box-coverflow"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "cover-img"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0,
  class: "custom-nav"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "custom-prev"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "custom-next"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));

const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "no-data"
};
const _hoisted_12 = {
  key: 2,
  class: "more"
};
const _hoisted_13 = ["href"];

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));

const _hoisted_16 = [_hoisted_14, _hoisted_15];
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Navigation, A11y, Autoplay, Pagination, EffectCoverflow } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import { Empty } from 'zhs-components';
import CommonTitle from './CommonTitle.vue';
export default {
  props: {
    menu: {
      type: Object,
      default: null
    }
  },

  setup(__props) {
    const props = __props;
    SwiperCore.use([Navigation, A11y, Autoplay, Pagination, EffectCoverflow]);
    const modules = [Navigation, A11y, Autoplay, Pagination, EffectCoverflow];
    const $http = inject('$http');
    const courseList = ref([]);

    const getCourseList = async () => {
      const res = await $http.getExcellentTextbook({
        '_pageable.page': 0,
        '_pageable.size': 999,
        menu_id: props.menu.menu_id
      }); // let timesToRepeat = 3
      // let repeatedArray = Array(timesToRepeat)
      //   .fill()
      //   .map(() => [...res.content])
      // courseList.value = [].concat(...repeatedArray)

      courseList.value = res.content;
    };

    getCourseList();

    const handleDetail = item => {
      if (item.access_method === 1) {
        window.location.href = `/textBookDetail.html?id=${item.id}&menuId=${props.menu.menu_id}&name=${props.menu.module_name}`;
      } else {
        window.open(item.link);
      }
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CommonTitle, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.menu && __props.menu.module_name || '优秀教材'), 1)]),
        _: 1
      }), courseList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(Swiper), {
        effect: 'coverflow',
        "grab-cursor": true,
        initialSlide: 1,
        slidesPerView: 4.4,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        "coverflow-effect": {
          scale: 0.9,
          rotate: 10,
          // Y 轴基础旋转角度（可根据需求调整）
          stretch: 0,
          // 卡片间距拉伸（负数更紧凑）
          depth: 50,
          // 深度效果（值越大立体越强）
          modifier: 1,
          // 修正系数
          slideShadows: false // 关闭默认阴影

        },
        watchSlidesProgress: true,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: '.custom-next',
          prevEl: '.custom-prev'
        },
        modules: modules,
        class: "swiper-content4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index,
            onClick: $event => handleDetail(item),
            class: "swiper-slide-custom"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
              src: item.cover || require('@/assets/images/video-cover.png'),
              alt: ""
            }, null, 8, _hoisted_5)])])]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 1
      }, 8, ["slidesPerView", "coverflow-effect", "navigation"]), courseList.value.length > 4 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(Empty), {
        text: "暂无教材"
      })])])), courseList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("a", {
        href: `/textBook.html?menuId=${__props.menu.menu_id}&name=${__props.menu.module_name}`
      }, _hoisted_16, 8, _hoisted_13)])) : _createCommentVNode("", true)]);
    };
  }

};